// One combined declaration needs every selected row to agree on its declaration fields.

// Early feedback only — bulkGenerateDeclarations re-checks the fuller set server-side.
const MATCH_FIELDS = Object.freeze([
  'materialName',
  'facilityName',
  'sendTo',
  'rawMaterialType',
  'countryOfOrigin',
  'ghgEmissions',
  'dateOfDispatch',
]);

export const rowsShareDeclarationFields = (rows = []) =>
  rows.length > 0 &&
  MATCH_FIELDS.every((field) => rows.every((row) => row[field] === rows[0][field]));
